export const initialState = {
    data: [],
    pageNum: 1,
    pageSize: 20,
    hasNext: true,
    total: 0,
    allCount: 0,
    loading: false,
    extra: {},
    code: null
}

export const reducer = (state, { type, payload, rowKey }) => {
    switch (type) {
        case 'UPDATE':
            return {
                ...state,
                ...payload
            }
        case 'UPDATE_ITEM':
            return {
                ...state,
                data: state.data.map(v => {
                    const key = rowKey ? rowKey : 'id'

                    if (v[key] === payload[key]) {
                        return {
                            ...v,
                            ...payload
                        }
                    }

                    return v
                })
            }
        case 'ADD_ITEMS': {
            const addCount = payload.length
            state.data = [...payload, ...state.data.slice(0, state.pageSize - addCount)]
            state.total += addCount
            return {
                ...state
            }
        }
        case 'RESET':
            return initialState
        default:
            return state
    }
}
